import type { PublicOfficer } from '../web3/officerDirectory';

type Props = {
  country: string;
  value: string;
  officers: PublicOfficer[];
  loading: boolean;
  error?: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => void;
};

const OfficerDidSelect = ({
  country,
  value,
  officers,
  loading,
  error,
  onChange,
}: Props) => {
  if (country === 'Other') {
    return (
      <div>
        <label htmlFor="sportsOfficer" className="block text-sm font-medium text-gray-700 mb-1">
          Sports Officer DID <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="sportsOfficer"
          name="sportsOfficer"
          value="Needs Review"
          disabled
          className="w-full px-4 py-2 border rounded-md bg-gray-100 text-gray-600"
        />
      </div>
    );
  }

  return (
    <div>
      <label htmlFor="sportsOfficer" className="block text-sm font-medium text-gray-700 mb-1">
        Sports Officer DID <span className="text-red-500">*</span>
      </label>
      <select
        id="sportsOfficer"
        name="sportsOfficer"
        value={value}
        onChange={onChange}
        disabled={!country || loading}
        className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-primary ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
      >
        <option value="">
          {loading
            ? 'Loading approved officers from the registry…'
            : country
              ? officers.length
                ? 'Select a Sports Officer DID'
                : 'No approved officer in this country yet'
              : 'Select a country first'}
        </option>
        {officers.map((officer) => (
          <option key={officer.applicationId} value={String(officer.didId)}>
            DID #{officer.didId}
          </option>
        ))}
      </select>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default OfficerDidSelect;
